import { render, staticRenderFns } from "./GraduateSchool.vue?vue&type=template&id=544f36ac"
import script from "./GraduateSchool.vue?vue&type=script&lang=js"
export * from "./GraduateSchool.vue?vue&type=script&lang=js"
import style0 from "./GraduateSchool.vue?vue&type=style&index=0&id=544f36ac&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports